

export const containerStyles = {
  backgroundColor: 'white',
  borderTop: '1px solid #dee2e6',
  paddingTop: '4rem'
};
